import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const SESSION_KEY = "statecraft_session_token";

export const getSessionToken = () => {
    try { return localStorage.getItem(SESSION_KEY); } catch { return null; }
};
export const setSessionToken = (token) => {
    try {
        if (token) localStorage.setItem(SESSION_KEY, token);
        else localStorage.removeItem(SESSION_KEY);
    } catch { /* storage disabled */ }
};
export const clearSessionToken = () => setSessionToken(null);

export const api = axios.create({
    baseURL: API_BASE,
    // withCredentials intentionally disabled — the platform ingress rewrites
    // Access-Control-Allow-Origin to '*' which is incompatible with credentials: include.
    // We use Bearer token (localStorage) instead, attached by the interceptor below.
    withCredentials: false,
});

// Attach Bearer token from localStorage. Bearer works cross-origin without CORS credentials,
// which is required because the platform ingress rewrites Access-Control-Allow-Origin to '*'
// on the preview domain — breaking cookie-based auth.
api.interceptors.request.use((config) => {
    // Explicitly clear credentials mode on EVERY request — belt & suspenders against
    // any code path that might have set it (browser cache, stale HMR module, or a
    // third-party interceptor). ACAO='*' from the platform ingress rejects credentials.
    config.withCredentials = false;
    const token = getSessionToken();
    if (token) {
        config.headers = config.headers || {};
        if (!config.headers.Authorization) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
});
